import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=1cd7ff1e&scoped=true&"
import script from "./orderRecord.vue?vue&type=script&lang=js&"
export * from "./orderRecord.vue?vue&type=script&lang=js&"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=1cd7ff1e&scoped=true&lang=css&"
import style1 from "./orderRecord.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderRecord.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd7ff1e",
  null
  
)

export default component.exports